// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__OAumi","banner-destop":"banner_banner-destop__5Ey1n","banner-tablet":"banner_banner-tablet__IwASW"};